export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-480-53ef4e799e875a106ea331c46312570f.webp";